import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { IpuService } from "../../services/IpuService";
import { ExercicioService } from "../../services/ExercicioService";

export default {
    name: "GerenciarIpus",
    components: {
        Breadcrumb,
        ActionButtons,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Ipus',
                disabled: true
            }
        ],
        // Controle de responsividade
        isMobile: false,
        isTablet: false,
        windowWidth: 0,
        // Headers base da tabela
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px', priority: 1 },
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', width: '100px', priority: 2 },
            { text: 'Código IPU', align: 'center', value: 'codigo_ipu', width: '150px', priority: 1 },
            { text: 'Descrição IPU', align: 'center', value: 'descricao', width: '300px', priority: 1 },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px', priority: 2 },
        ],
        filters: {
            codigoIpuFilter: '',
            descricaoIpuFilter: '',
            exercicioFilter: null,
            statusFilter: null,
        },
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        items: [],
        itemSelected: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        showFilters: true,
        loading: false,
        exerciciosOptions: []
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        // Headers computados - sempre mostra todas as colunas
        computedHeaders() {
            // Sempre retorna todas as colunas, independente da resolução
            // O scroll horizontal cuidará da navegação em telas pequenas
            return this.baseHeaders;
        }
    },
    created() {
        this.listarIpusPaginado();
        this.listarExerciciosSelect();
        this.handleResize();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        'filters.codigoIpuFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarIpusPaginado();
            }
        },
        'filters.descricaoIpuFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarIpusPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarIpusPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarIpusPaginado();
            }
        }
    },
    methods: {
        async listarIpusPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await IpuService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os ipus.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os ipus:', error);
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Todos",
                        value: null,
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        async destroyIpus() {
            try {
                const ids = this.itemSelected.map(ipu => ipu.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("ipus[]", id);
                });

                const response = await IpuService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os ipus.');
                }

                this.listarIpusPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os ipus:', error);
            }
        },
        async activateIpus() {
            try {
                const ids = this.itemSelected.map(ipu => ipu.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("ipus[]", id);
                });

                const response = await IpuService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os ipus.');
                }

                this.listarIpusPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os ipus:', error);
            }
        },
        async deactivateIpus() {
            try {
                const ids = this.itemSelected.map(ipu => ipu.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("ipus[]", id);
                });

                const response = await IpuService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os ipus.');
                }

                this.listarIpusPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os ipus:', error);
            }
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            if (this.filters.codigoIpuFilter) {
                filter.append("codigo", this.filters.codigoIpuFilter);
            }

            if (this.filters.descricaoIpuFilter) {
                filter.append("descricao", this.filters.descricaoIpuFilter);
            }

            if (this.filters.exercicioFilter) {
                filter.append("exercicio", this.filters.exercicioFilter);
            }

            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }

            return filter;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getRowClass(item) {
            return item.ativo ? 'row-active' : 'row-inactive';
        },
        navigateToCreate() {
            this.$router.push('/ipus/criar');
        },
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/ipu/editar/${this.itemSelected[0].id}`);
            }
        },
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        handlePageChanged(page) {
            this.page = page;
            this.listarIpusPaginado();
        },
        handleItemsPerPageChanged(itemsPerPage) {
            this.itemsPerPage = itemsPerPage;
            this.page = 1;
            this.listarIpusPaginado();
        },

        // Método para detectar mudanças no tamanho da tela
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768;
            this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
        }
    }
};
